var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .puchipuchi_een{fill:#111918;} "), /*#__PURE__*/React.createElement("path", {
    className: "puchipuchi_een",
    d: "M28,11V3c0-1.1-0.9-2-2-2H6C4.9,1,4,1.9,4,3v8H28z M7,4c0-0.55,0.45-1,1-1h16c0.55,0,1,0.45,1,1v4 c0,0.55-0.45,1-1,1H8C7.45,9,7,8.55,7,8V4z M4,12v17c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V12H4z M8.5,28C7.672,28,7,27.328,7,26.5 S7.672,25,8.5,25s1.5,0.672,1.5,1.5S9.328,28,8.5,28z M8.5,23C7.672,23,7,22.328,7,21.5S7.672,20,8.5,20s1.5,0.672,1.5,1.5 S9.328,23,8.5,23z M8.5,18C7.672,18,7,17.328,7,16.5S7.672,15,8.5,15s1.5,0.672,1.5,1.5S9.328,18,8.5,18z M13.5,28 c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S14.328,28,13.5,28z M13.5,23c-0.828,0-1.5-0.672-1.5-1.5 s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S14.328,23,13.5,23z M13.5,18c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5 S14.328,18,13.5,18z M18.5,28c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S19.328,28,18.5,28z M18.5,23 c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S19.328,23,18.5,23z M18.5,18c-0.828,0-1.5-0.672-1.5-1.5 s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S19.328,18,18.5,18z M25,26.5c0,0.829-0.671,1.5-1.5,1.5S22,27.329,22,26.5v-5 c0-0.829,0.671-1.5,1.5-1.5s1.5,0.671,1.5,1.5V26.5z M23.5,18c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5 S24.328,18,23.5,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalc);
export default __webpack_public_path__ + "static/media/calc.5689acb96a3e0925cee57772afa15990.svg";
export { ForwardRef as ReactComponent };